import { Button, Flex, Tabs } from "antd";
import { Link, useNavigate, useParams } from "react-router";
import { usePublicCourseDetailsQuery } from "../../../app/features/adminContent/adminContent.api";
import AnalyticsIcon from "../../../assets/icons/AnaliticsIcon";
import AnnouncementsIcon from "../../../assets/icons/AnnouncementsIcon";
import ArrowLeftIcon from "../../../assets/icons/ArrowLeftIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import LearnersIcon from "../../../assets/icons/LearnersIcon";
import ReviewIcon from "../../../assets/icons/ReviewIcon";
import DashboardIcon from "../../../layouts/_icons/DashboardIcon";
import DashboardLayout from "../../../layouts/DashboardLayout";
import Analytics from "./_components/Analytics/Analytics";
import Announcements from "./_components/Announcements";
import Learners from "./_components/Learners";
import Overview from "./_components/Overview";
import Rating from "./_components/Rating/Rating";

export default function MyCourseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: courseDetails, isLoading } = usePublicCourseDetailsQuery(
    Number(id),
    {
      skip: !id,
    },
  );

  // const [deleteCourse, { isLoading: isDeleting }] = useDeleteCourseMutation();

  // const handleDeleteCourse = () => {
  //   if (!id) return;

  //   Modal.confirm({
  //     title: "Are you sure you want to delete this course?",
  //     content:
  //       "This action cannot be undone. All course content will be permanently removed.",
  //     okText: "Yes, Delete",
  //     okType: "danger",
  //     cancelText: "Cancel",
  //     onOk: async () => {
  //       try {
  //         await deleteCourse({ id: Number(id) }).unwrap();
  //         message.success("Course deleted successfully");
  //         navigate("/admin/my-course");
  //       } catch (error) {
  //         message.error("Failed to delete course");
  //       }
  //     },
  //     okButtonProps: { loading: isDeleting },
  //   });
  // };

  const handleBack = () => {
    navigate(-1);
  };

  const items = [
    {
      key: "1",
      label: (
        <Flex align="center" gap={8}>
          <DashboardIcon /> Overview
        </Flex>
      ),
      children: (
        <Overview courseDetails={courseDetails} isLoading={isLoading} />
      ),
    },
    {
      key: "2",
      label: (
        <Flex align="center" gap={8}>
          <AnalyticsIcon /> Analytics
        </Flex>
      ),
      children: <Analytics />,
    },
    {
      key: "3",
      label: (
        <Flex align="center" gap={8}>
          <ReviewIcon /> Reviews
        </Flex>
      ),
      children: <Rating />,
    },
    {
      key: "4",
      label: (
        <Flex align="center" gap={8}>
          <LearnersIcon />
          Learners
        </Flex>
      ),
      children: <Learners />,
    },
    {
      key: "5",
      label: (
        <Flex align="center" gap={8}>
          <AnnouncementsIcon />
          Announcements
        </Flex>
      ),
      children: <Announcements />,
    },
  ];

  return (
    <DashboardLayout title="My Courses Details">
      {/* Header Section */}
      <div className="mb-6">
        <Flex justify="space-between" wrap align="start">
          <Flex align="center" wrap gap={15}>
            <Button
              size="middle"
              onClick={handleBack}
              icon={<ArrowLeftIcon size={16} />}
              classNames={{ icon: "mt-0.5" }}
            >
              Back
            </Button>
            <h2 className="text-2xl font-bold text-theme-slate-700">
              {isLoading
                ? "Loading..."
                : courseDetails?.title || "Untitled Course"}
            </h2>
            <span className="bg-slate-100 text-slate-500 px-2 py-0.5 rounded text-xs font-medium mt-0.5">
              {courseDetails?.status || "Draft"}
            </span>
          </Flex>

          <Flex gap={12}>
            {/* <Link to="#">
              <Button className="btn-bordered">
                <ViewIcon size={16} /> View Course
              </Button>
            </Link>
            <Button
              danger
              className="bg-white text-red-600 border-red-200 hover:bg-red-50 hover:border-red-300"
              onClick={handleDeleteCourse}
              loading={isDeleting}
            >
              Delete Course
            </Button> */}
            <Link to={`/admin/my-course/manage-course/${id}`}>
              <Button
                type="primary"
                className="bg-theme-primary text-white shadow-sm"
              >
                <EditIcon size={16} /> Edit Course
              </Button>
            </Link>
          </Flex>
        </Flex>
      </div>

      {/* Tabs */}
      <Tabs
        defaultActiveKey="1"
        items={items}
        className="custom-tabs"
        tabBarStyle={{ marginBottom: 30 }}
      />
    </DashboardLayout>
  );
}
